'use client'

import React, { useEffect, useState } from "react";
import { motion } from 'framer-motion';
import { Container, Typography, Box, IconButton } from '@mui/material';
import Link from 'next/link';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ImageModal from "@/components/ui/ImageModal";
import Image from 'next/image';

export const ProjektDetailSection = ({ content, bilder, nextProjectId, previousProjectId }) => {
    const [columnCount, setColumnCount] = useState(3);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(null);

    // Die Bilder kommen aus getStaticProps (Bild-Manifest). Frueher wurden sie
    // beim Rendern per fetch von /api/getImages nachgeladen, das dafuer bei
    // jedem Aufruf das Dateisystem durchsuchte.
    const imageArr = bilder ?? [];

    
    const openModal = (index) => {
        setCurrentImageIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const nextImage = () => {
        if (currentImageIndex !== null) {
            setCurrentImageIndex((currentImageIndex + 1) % imageArr.length);
        }
    };

    const previousImage = () => {
        if (currentImageIndex !== null) {
            setCurrentImageIndex((currentImageIndex - 1 + imageArr.length) % imageArr.length);
        }
    };

    useEffect(() => {
        const updateColumnCount = () => {
            if (window.innerWidth < 600) {
                setColumnCount(1);
            } else if (window.innerWidth >= 600 && window.innerWidth < 900) {
                setColumnCount(2);
            } else if (window.innerWidth >= 900 && window.innerWidth < 1200) {
                setColumnCount(4);
            } else {
                setColumnCount(5);
            }
        };

        window.addEventListener('resize', updateColumnCount);
        updateColumnCount(); // Initial check on component mount

        return () => window.removeEventListener('resize', updateColumnCount);
    }, []);

    const masonryStyle = {
        columnCount: columnCount,
        columnGap: "1rem",
        marginTop: "2rem"
    };

    const boxStyle = {
        width: '100%',
        marginBottom: '1rem',
        cursor: 'pointer',
        position: 'relative',
        height: 'auto',
    };

    const currentImage = imageArr[currentImageIndex] ?? null;


    return (
        <motion.section
            className="section-large"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom>
                        {content.titel}
                    </Typography>
                <div className="section-navigation">
                    {previousProjectId && previousProjectId != content.projekt_id && (
                        <IconButton component={Link} href={`/projekte/${previousProjectId}`} aria-label="Vorheriges Projekt">
                            <ArrowBackIcon />
                        </IconButton>
                    )}
                    {nextProjectId && nextProjectId != content.projekt_id && (
                        <IconButton component={Link} href={`/projekte/${nextProjectId}`} aria-label="Nächstes Projekt">
                            <ArrowForwardIcon />
                        </IconButton>
                    )}
                </div>
                </div>
            </div>
            <div className="section-body">
                <Container maxWidth="full" className="no-padding">
                    <Typography variant="h6" component="h2" paragraph>
                        {content.untertitel}
                    </Typography>
                    <Typography variant="caption">
                        {content.jahr} - {content.projektart}
                    </Typography>
                    <Typography variant="body2">
                        {content.beschreibung}
                    </Typography>
                    <Typography variant="caption">
                        {content.bauinfos}
                    </Typography>
                    <div style={masonryStyle}>
                        {imageArr && imageArr.length > 0 && imageArr.map((image, index) => {
                            return (
                                <Box component="button" type="button" aria-label={`Bild ${index + 1} vergrössern`} key={image.url} sx={{ ...boxStyle, display: 'block', border: 0, padding: 0, background: 'none' }} onClick={() => openModal(index)}>
                                    <Image
                                        src={image.url}
                                        alt={image.name}
                                        width={500}
                                        height={Math.round((image.height / image.width) * 500)} // Maintain aspect ratio
                                        style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                                        loading="lazy"
                                    />
                                </Box>
                            );
                        })}
                    </div>
                    {currentImage && <ImageModal
                        isOpen={isModalOpen}
                        onClose={closeModal}
                        imageSrc={currentImage.url}
                        altText={currentImage.name}
                        width={currentImage.width}
                        height={currentImage.height}
                        next={currentImageIndex !== null && imageArr.length > 1 ? nextImage : null}
                        previous={currentImageIndex !== null && imageArr.length > 1 ? previousImage : null}
                    />}
                </Container>
            </div>
        </motion.section>
    );
};
